import React, { Component } from "react";
import { v4 as uuidv4 } from "uuid";
import FormsContainer from "../components/formBuilder/components/FormsContainer";
import { FormBuilderObjects } from "../variables/formBuilderData";
import FormInputConfig from "../components/formBuilder/components/FormInputConfig";
import Responsive from "../components/Responsive";
import { conditionalWidth, imageAddress, translate } from "../utils/useful";
import FormBuilderTopbar from "../components/formBuilder/components/FormBuilderTopbar";
import QuestionSideBar from "./formBuilder/components/QuestionSideBar";
import LoaderButton from "./LoaderButton";
import HttpServices from "../utils/Http.services";
import Modal from "./Modal";
import ButtonAnimated from "./buttons/ButtonAnimated";
import SidebarView from "./SidebarView";


class FormBuilder extends Component {
    state = {
        currentPage: 0,
        formContent: [
            {
                pageId: uuidv4(),
                pageContent: [{
                    sectionId: uuidv4(),
                    sectionContent: [
                        {
                            rowId: uuidv4(),
                            rowContent: [
                            ],
                        }
                    ]
                }]

            }
        ],

        showhandlers: false,
        formData: []
    };


    componentDidMount() {
        // console.log('this.propsfss', this.props)
        if (this.props.initData) {
            let initData
            if (Array.isArray(this.props.initData) && !this.props.initData[0].pageContent) {
                initData = [{
                    pageId: uuidv4(),
                    pageContent: [{
                        sectionId: uuidv4(),
                        sectionContent: [
                        ]
                    }]

                }]
                this.props.initData.map((element, index) => {
                    initData[0].pageContent[0].sectionContent[index] = {
                        rowId: uuidv4(),
                        rowContent: [element]
                    }
                })

            }
            else {
                initData = this.props.initData
            }
            // console.log('initdata', initData)
            this.setState({ formContent: initData })
        }
        // this.props.changeBackbtn(true)
        if (this.props.editForm) {
            if (this.props.setHeader) {
                this.props.setHeader({
                    'toolbar': null,
                    'showToolbar': false,
                    topHeaderComponent: this.topHeaderComponent,
                    title: '{{lang}}Edit Inquiry',
                    // headerIdentityComponent: this.headerIdentityComponent,
                    backAction: () => {
                        // this.props.changePage(this.props.collectionId);
                        this.props.changeStage('info')
                    }
                })
            }
            // let quizName = this.props.initData
            // this.props.setHeader({
            //     'toolbar': null,
            //     'showToolbar': false,
            //     topHeaderComponent: this.topHeaderComponent,
            //     title: '{{lang}}Edit Inquery',
            //     // headerIdentityComponent: this.headerIdentityComponent,
            //     backAction: () => this.props.changeStage('info')

            // })
        }
        else {
            this.props.setHeader({
                'toolbar': null,
                'showToolbar': false,
                topHeaderComponent: this.topHeaderComponent,
                title: '{{lang}}New Inquery',
                // headerIdentityComponent: this.headerIdentityComponent,
                backAction: () => this.props.changeStage('info')

            })
        }


    }


    topHeaderComponent = () => {
        return (
            <div className='flexc'>

                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.nextStage}
                    title={'{{lang}}Next'}
                    icon='/assets/icons/arrow-right-white.svg'
                    textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />

            </div>

        )
    }
    topHeaderEditComponent = () => {
        return (
            <div className='flexc'>
                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.showSubmitModal}
                    title={this.props.editForm ? '{{lang}}Edit' : '{{lang}}Create'}
                    icon='/assets/icons/arrow-right-white.svg'
                    textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />
            </div>

        )
    }
    // topHeaderEditComponent = () => {
    //     return (
    //         <div className='flexc'>
    //             <ButtonAnimated
    //                 iconwidth='24px'
    //                 onClick={this.showSubmitModal}
    //                 title={this.props.editForm ? '{{lang}}Edit' : '{{lang}}Create'}
    //                 icon='/assets/icons/arrow-right-white.svg'
    //                 textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
    //                 invert={!this.props.colors?.iconInvert}
    //                 bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
    //             />
    //         </div>

    //     )
    // }



    componentDidUpdate(prevProps) {
        if (prevProps.initData != this.props.initData && this.props.initData) {

            this.setState({ formContent: this.props.initData })

        }
    }
    setFormData = (value) => {
        this.setState({ formData: value })
    }

    onSave = () => {
        if (this.props.onSave) {
            let data = this.state.formContent
            this.props.onSave(data)
        }
    }
    nextStage = (stage) => {

        let rawData = this.state.formContent
        if (rawData && rawData[0]?.pageContent && rawData[0]?.pageContent[0]) {
            let questions = []
            rawData[0].pageContent[0].sectionContent.map((prop) => {
                prop.rowContent.map((element) => {
                    questions.push({ ...element })
                })
            })

            // this.props.postRecord(() => {
            let scoreHeader = []
            questions.forEach(el => {
                scoreHeader.push(
                    { key: `${el.key}`, id: `${el.id}`, type: 'NumberInput', information: { disabled: false, label: "{{lang}}Score", placeholder: "{{lang}}Score" } }
                )
            });
            this.props.setData({ 'values.questions': questions }, () => {
                console.log('scoreHeader11',scoreHeader)
                this.props.setData({ 'values.scoreHeader': scoreHeader }, () => {
                    this.props.changeStage('answerSheet')
                    // this.submitModal.hideModal()
                })
            })
            // })
        }
    }
    // nextStage = (stage) => {

    //     let rawData = this.state.formContent
    //     console.log(rawData)
    //     if (rawData && rawData[0]?.pageContent && rawData[0]?.pageContent[0]) {
    //         let questions = []
    //         rawData[0].pageContent[0].sectionContent.map((prop) => {
    //             prop.rowContent.map((element) => {
    //                 questions.push({ ...element })
    //             })
    //         })

    //         this.props.setData({ 'values.questions': questions }, () => {
    //             this.props.postRecord(() => {
    //                 this.submitModal.hideModal()
    //             })
    //         })
    //     }
    // }

    editNextStage = (stage) => {

        let rawData = this.state.formContent
        if (rawData) {

            let questions = []
            rawData[0].pageContent[0].sectionContent.map((prop) => {
                prop.rowContent.map((element) => {
                    questions.push(element)
                })
            })

            this.props.setData({ 'values.questions': questions }, () => {
                this.props.postEditRecord(() => {
                    this.submitModal.hideModal()
                })
            })
        }
    }

    showSubmitModal = () => {
        this.submitModal.showModal()
    }

    submitConfig = (header) => {

        let data = this.state.currentData
        let currentHeader = this.state.currentHeader
        // console.log('aaaaaaaaaaaa', currentHeader)

        let formContent = JSON.parse(JSON.stringify(this.state.formContent))
        formContent.forEach(page => {
            page.pageContent.forEach(section => {
                section.sectionContent.forEach(row => {
                    row.rowContent.forEach(input => {

                        if (input.key == currentHeader.key) {
                            // data = { ...input }
                            // console.log(input)
                            input.information = data.information
                        }
                    });
                });
            });
        })
        this.infoSidebar.close()

        this.setFormContent(formContent)

        this.setState({ sideOpen: false, showConfig: false }, () => { })

    }

    openInputConfig = (header) => {
        if (this.FormInputConfig) {
            this.FormInputConfig.validateForm((isvalid) => {
                if (!isvalid) {
                    return
                }
                this.openInputConfigAct(header)
            })
        } else {
            this.openInputConfigAct(header)
        }
    }

    render() {
        const { formsRows, formItems, showhandlers } = this.state;
        let page = this.state.formContent[this.state.currentPage]
        return (
            <div className='w-100 window-content-radius-bottom  pb-0 h-100 ' style={{ zIndex: 10, overflow: 'hidden' }}>
                {/* {this.props.editForm &&
                    // <div className='w-100'>
                    <div className="flexcb px-2 py-2" style={{ position: 'sticky', top: '52px', zIndex: 1, borderBottom: '1px solid #eee', backgroundColor: '#f6f6f6' }}>
                        <div className="flexc">
                            <button onClick={() => { this.props.changeStage('info') }}>
                                <img src='/assets/icons/arrow-left-black.svg' />
                            </button>
                            <div className="flexc  py-2 px-3">
                                <div className="flexcc br-4 text-big color-white text-bold" style={{ height: 22, width: 22, background: this.props.colors?.background ?? 'linear-gradient(90deg, rgb(24, 77, 148), rgb(36, 106, 199))' }}>
                                    <p>+</p>
                                </div>
                                <p className="text-bold text-normal px-1">{translate("useful.Edit")}</p>
                            </div>
                        </div>
                        <div className="flexce w-100 px-2 scroll-no-scrollbar">

                            <div className=" mld-2">
                                <div className='flexc'>
                                    <ButtonAnimated
                                        iconwidth='24px'
                                        onClick={this.showSubmitModal}
                                        title={translate('Edit')}
                                        icon='/assets/icons/arrow-right-white.svg'
                                        textColor={this.props.colors?.textColor ?? '#000'}
                                        bg={this.props.colors.background ?? '#fff'}
                                        // invert={!this.props.colors?.iconInvert}
                                        isLoading={this.props.isLoading}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    // </div>
                } */}

                <SidebarView width={this.props.width} ref={el => this.infoSidebar = el} hideOverlay={false} widthCondition={{ xs: "60%", sm: "50%", md: '50%', lg: "40%", xl: "30%" }} onClose={this.onClose} >

                    {this.state.showConfig && (
                        <FormInputConfig ref={el => this.FormInputConfig = el} updateInputData={this.updateInputData} headers={this.state.currentInput?.headers} initData={this.state.currentData?.information} input={this.state.currentInput} submit={this.submitConfig} colors={this.props.colors} />
                    )}
                    <button className={"close-hide sideHandler blur-back flexcc "} onClick={e => this.openInputConfig(null)}>
                        <img src="/images/next-2.png" width="20px" alt="" />
                    </button>

                </SidebarView>

                <div ref={el => this.formBuilder = el} className={" h-100 " + (conditionalWidth(this.props.width, { xs: 'd-block', md: 'd-flex' }))}>
                    <Responsive width={this.props.width} height={'100%'} media={{ xs: 'none', sm: 'none', md: '3', lg: '3', xl: '2' }}>
                        <div className="h-100 scroll-no-scrollbar" style={{ backgroundColor: '#f6f6f6' }}>
                            <QuestionSideBar
                                onSave={this.onSave}
                                formItems={Object.values(FormBuilderObjects)}
                                showhandlers={() => this.setState({ showhandlers: true })}
                                hideHandlers={() => this.setState({ showhandlers: false })}
                                lastStage={this.props.lastStage}
                                saveTitle={this.props.saveTitle}
                                page={this.props.type}
                                language={this.props.language}
                            />
                        </div>
                    </Responsive>

                    <div className={"position-sticky w-100 " + (conditionalWidth(this.props.width, { xs: '', md: ' d-none ' }))} style={{ top: 0, zIndex: 1 }}>
                        <FormBuilderTopbar
                            formItems={Object.values(FormBuilderObjects)}
                            showhandlers={() => this.setState({ showhandlers: true })}
                            hideHandlers={() => this.setState({ showhandlers: false })}
                            language={this.props.language}
                        />

                    </div>






                    <Responsive width={this.props.width} height={conditionalWidth(this.props.width, { xs: 'calc(100% - 80px)', md: '100%' })} media={{ xs: '12', sm: '12', md: '9', lg: '9', xl: '10' }}>
                        <div className="h-100 scroll-no-scrollbar">

                            <div className='h-100'>
                                <FormsContainer
                                    ref={el => this.formsContainer = el}
                                    inputClass={'modern-input'}
                                    formClass={null}
                                    pageContent={page.pageContent}
                                    pageIndex={this.state.currentPage}
                                    pageId={page.pageId}
                                    setFormData={this.setFormData}
                                    addnewItem={this.addnewItem}
                                    openInputConfig={this.openInputConfig}
                                    changeInputPosition={this.changeInputPosition}
                                    showhandlers={showhandlers}
                                    showhandlersFunc={() =>
                                        this.setState({ showhandlers: true })
                                    }
                                    hideHandlersFunc={() =>
                                        this.setState({ showhandlers: false })
                                    }
                                    deleteInput={this.deleteInput}
                                    language={this.props.language}
                                />
                            </div>
                        </div>
                    </Responsive >
                </div>
                <Modal ref={el => this.submitModal = el} maxWidth={400}>
                    <div className="flexcc flex-column p-3 bg-white br-15" >
                        <p className="text-center text-semibig main-c3 text-semibold mt-2">{this.props.editForm ? translate("Edit Inquiry") : translate("Create Inquiry")}</p>
                        <p className="text-center font-size-13 main-c7 mt-2 px-2">{translate('Are you sure about the information? If all is ok, click confirm to create the inquiry')}</p>
                        <div className="flexcc w-100 mt-4 mb-2" style={{}}>

                            {/* <button className="modalCancelButton mrd-2 br-20" onClick={() => this.submitModal.hideModal()}>
                                <p className="font-size-14">{translate('Cancel')}</p>
                            </button> */}
                            <div className="mrd-1">
                                <ButtonAnimated
                                    // icon={'/assets/icons/check-white.svg'}
                                    bg={'rgba(120, 120, 120, 0.1)'}
                                    textColor={'rgb(120, 120, 120)'}
                                    title={'{{lang}}Cancel'}
                                    onClick={() => this.submitModal.hideModal()}
                                />
                            </div>
                            <div className="mld-1">
                                {this.props.editForm ?
                                    <ButtonAnimated
                                        icon={'/assets/icons/check-white.svg'}
                                        bg={this.props.colors?.background}
                                        textColor={this.props.colors?.textColor}
                                        title={'{{lang}}Edit'}
                                        onClick={() => this.editNextStage()}
                                    />
                                    :
                                    <ButtonAnimated
                                        icon={'/assets/icons/check-white.svg'}
                                        bg={this.props.colors?.background}
                                        textColor={this.props.colors?.textColor}
                                        title={'{{lang}}Create'}
                                        onClick={() => this.nextStage()}
                                    />
                                }
                            </div>
                            {/* <button className='modalConfirmButton mld-2 w-100' onClick={() => { this.nextStage() }}>
                                <p className="fotn-size-14">{translate('Confirm')}</p>
                            </button> */}
                        </div>
                    </div>
                </Modal>
                {/* <div style={{ position: 'fixed', bottom: 10, right: 10 }}>
                    <ButtonAnimated icon={'/assets/icons/check-white.svg'} bg={this.props.colors?.background} textColor={this.props.colors?.textColor} title={'Submit'} onClick={() => this.showSubmitModal()} />
                </div> */}
            </div >
        );
    }







    addnewItem = (key, rowId, sectionId, pageId, direction, inputIndex) => {

        let foundInput = FormBuilderObjects[key];

        let formContent = this.state.formContent
        let pageIndex
        let sectionIndex

        formContent.forEach((page, index) => {
            if (page.pageId == pageId) {
                pageIndex = index
            }
        });

        if (pageIndex != null) {
            formContent[pageIndex].pageContent.forEach((section, index) => {
                if (section.sectionId == sectionId) {
                    sectionIndex = index
                }
            });
        }


        if (pageIndex != null && sectionId != null) {

            let formsRows = [...formContent[pageIndex].pageContent[sectionIndex].sectionContent];
            let foundRow = formsRows.find((row) => row.rowId == rowId);
            let foundRowIndex = formsRows.indexOf(foundRow);

            let placehoder = '{{lang}}' + foundInput?.label

            foundInput.headers.forEach(header => {
                if (header.key == 'placeholder' && header.information.defaultValue) {
                    placehoder = header.information.defaultValue
                }
            });

            let information = { label: foundInput?.label, placeholder: placehoder }
            let keyId = uuidv4()
            let newRowInput = { id: keyId, key: keyId, type: foundInput?.type, information: information };
            let newRow = {
                rowId: uuidv4(),
                rowContent: []
            };
            if (!direction) {
                foundRow.rowContent.push(newRowInput);
            }

            if (direction) {
                switch (direction) {
                    case "top":
                        newRow.rowContent.push(newRowInput);
                        formsRows.unshift(newRow);
                        break;
                    case "bottom":

                        newRow.rowContent.push(newRowInput);
                        formsRows.splice(foundRowIndex + 1, 0, newRow);
                        // formsRows.push(newRow)


                        break;

                    case 'left':
                        foundRow.rowContent.unshift(newRowInput);
                        break;
                    case 'right':

                        foundRow.rowContent.splice(inputIndex + 1, 0, newRowInput)
                        break
                    default:
                        break;
                }
            }

            formContent[pageIndex].pageContent[sectionIndex].sectionContent = formsRows

            this.setState({ formContent }, () => { });


        }
    };

    changeInputPosition = (inputId, type, rowId, sectionId, pageId, DRowID, DSectionId, DPageId, direction, inputIndex) => {


        let formContent = this.state.formContent
        let pageIndex
        let sectionIndex
        let DPageIndex
        let DSectionIndex

        formContent.forEach((page, index) => {
            if (page.pageId == pageId) {
                pageIndex = index
            }
        });

        formContent.forEach((page, index) => {
            if (page.pageId == DPageId) {
                DPageIndex = index
            }
        });

        if (pageIndex != null) {
            formContent[pageIndex].pageContent.forEach((section, index) => {
                if (section.sectionId == sectionId) {
                    sectionIndex = index
                }
            });
        }

        if (DPageIndex != null) {
            formContent[DPageIndex].pageContent.forEach((section, index) => {
                if (section.sectionId == DSectionId) {
                    DSectionIndex = index
                }
            });
        }

        if (pageIndex != null && sectionIndex != null && DPageIndex != null && DSectionIndex != null) {


            let formsRows = [...formContent[pageIndex].pageContent[sectionIndex].sectionContent];
            let DformsRows = [...formContent[DPageIndex].pageContent[DSectionIndex].sectionContent];
            let foundRow = formsRows.find((row) => row.rowId == rowId)
            let destinationRow = DformsRows.find((row) => row.rowId == DRowID)
            let destinationRowIndex = DformsRows.indexOf(destinationRow)
            let foundInput = foundRow.rowContent.find((input) => input.id == inputId);
            let foundInputIndex = foundRow.rowContent.indexOf(foundInput);
            foundRow.rowContent.splice(foundInputIndex, 1);
            let foundRowIndex = formsRows.indexOf(foundRow);
            let newRowInput = foundInput;
            let newRow = {
                rowId: uuidv4(),
                rowContent: []
            };

            switch (direction) {
                case "top":
                    if (foundRowIndex == destinationRowIndex) return;
                    if (foundRow.rowContent.length == 0) {
                        formsRows.splice(foundRowIndex, 1)
                    }
                    newRow.rowContent.push(newRowInput);
                    formsRows.unshift(newRow);
                    break;
                case "bottom":
                    if (foundRow.rowContent.length == 0) {
                        newRow.rowContent.push(foundInput);
                        formsRows.splice(foundRowIndex, 1)
                        formsRows.splice(destinationRowIndex, 0, newRow);

                    }
                    else {
                        newRow.rowContent.push(foundInput);
                        formsRows.splice(destinationRowIndex + 1, 0, newRow);


                    }
                    break;

                case 'left':

                    destinationRow.rowContent.unshift(foundInput);

                    if (foundRow.rowContent.length == 0) {


                        formsRows.splice(foundRowIndex, 1);

                    }
                    break;
                case 'right':


                    destinationRow.rowContent.splice(inputIndex + 1, 0, foundInput)
                    if (foundRow.rowContent.length == 0) {


                        formsRows.splice(foundRowIndex, 1);

                    }
                    break
                default:
                    break;
            }

            formContent[pageIndex].pageContent[sectionIndex].sectionContent = formsRows
            this.setState({ formContent }, () => {

            })
        }
    };

    deleteInput = (inputId, rowid, sectionId, pageId) => {


        let pageIndex
        let sectionIndex

        let formContent = this.state.formContent

        formContent.forEach((page, index) => {
            if (page.pageId == pageId) {
                pageIndex = index
            }
        });


        if (pageIndex != null) {
            formContent[pageIndex].pageContent.forEach((section, index) => {
                if (section.sectionId == sectionId) {
                    sectionIndex = index
                }
            });
        }

        if (pageIndex != null && sectionId != null) {

            let formsRows = [...formContent[pageIndex].pageContent[sectionIndex].sectionContent];

            // 
            let foundRow = formsRows.find(row => row.rowId == rowid)
            let foundRowIndex = formsRows.indexOf(foundRow);
            let inputIndex = formsRows[foundRowIndex].rowContent.indexOf(foundRow.rowContent.find(input => input.id == inputId));

            let removedHeader = formsRows[foundRowIndex].rowContent[inputIndex]

            formsRows[foundRowIndex].rowContent.splice(inputIndex, 1)

            if (foundRow.rowContent.length == 0) {
                formsRows.splice(foundRowIndex, 1)
            }
            let newRow = {
                rowId: uuidv4(),
                rowContent: []
            };
            if (formsRows.length == 0) {
                formsRows.push(newRow)
            }

            formContent[pageIndex].pageContent[sectionIndex].sectionContent = formsRows

            this.setState({ formContent }, () => {
            })



            if (removedHeader.key == this.state.currentData?.key) {
                this.openInputConfig(null)
            }

        }

    }


    openInputConfigAct(header) {

        let sideOpen = header != null ? true : false

        if (sideOpen && header && FormBuilderObjects[header.type]) {


            let data = null

            let formContent = this.state.formContent

            formContent.forEach(page => {
                page.pageContent.forEach(section => {

                    section.sectionContent.forEach(row => {
                        row.rowContent.forEach(input => {
                            if (input.key == header.key) {
                                data = { ...input }
                            }
                        });
                    });
                });
            })

            this.infoSidebar.open()
            this.setState({ sideOpen, currentInput: FormBuilderObjects[header.type], currentHeader: header, currentData: data, showConfig: false }, () => {
                this.setState({ showConfig: true })
            })




        } else {

            this.infoSidebar.close()

            this.setState({ sideOpen: false, currentInput: null, showConfig: false }, () => {
                this.setState({ showConfig: true })
            })


        }

    }

    updateInputData = (key, value) => {
        let data = this.state.currentData
        data.information[key] = value
        this.setState({ currentData: data })
    }

}

export default FormBuilder;
